import React, { createContext, useContext, ReactNode, useState } from 'react';
import Axios from 'axios';
import useSWR from 'swr'
import { Spinner } from 'react-bootstrap';

const axiosFetcher = (url: string) => Axios.get(url).then((d) => {
  let counter = 0;
  let divCounter = 0;
  const filterNodesWithNodeNameP = (node: any, result: any = {}) => {
    
    if (node["node-name"] === "p") {
      counter = counter + 1;
      result[node.attributes.find((a: any) => a.name === "xml:id")?.value] = {...node, count: counter};
    }
    if (node["child-nodes"]){
      for (const child of node["child-nodes"]){
        filterNodesWithNodeNameP(child, result)
      }
    }
    return result;
  }
  const filterElementNodes = (node: any, result: any = {}) => {
    if (node["node-name"] === "p") {
      const elementNodes = getElementNodes(node["child-nodes"]);
      result[node?.attributes.find((a: any) => a.name === "xml:id")?.value] = 
      { 
        elementNodes: elementNodes,
      };
    }
    if (node["child-nodes"]){
      for (const child of node["child-nodes"]){
        filterElementNodes(child, result)
      }
    }
    return result;
}
  const filterNodesWithNodeNameD = (node: any, result: any = {}) => {
    if (node["node-name"] === "div") {
      divCounter = divCounter + 1;
      const headNodes = getHeadNodes(node["child-nodes"]);
      const firstPNode = getFirstPNode(node["child-nodes"]);
      result[node?.attributes.find((a: any) => a.name === "xml:id")?.value] = 
      { count: divCounter,
        headNodes: headNodes,
        firstPNodeId: firstPNode || divCounter + 1
      };
    }
    if (node["child-nodes"]){
      for (const child of node["child-nodes"]){
        filterNodesWithNodeNameD(child, result)
      }
    }
    return result;
  }
  const getHeadNodes = (childNodes: any[]) => {
    const headNodes = [];
    for (const child of childNodes) {
      if (child["node-name"] === "head") {
        headNodes.push(child);
      }
    }
    return headNodes;
  };
  const getElementNodes = (childNodes: any[]) => {
    const elementNodes: any[] = [];
    const recursiveSearch = (nodes: any[]) => {
      for (const node of nodes) {
        if (node["node-name"] === "quote" || node["node-name"] === "ref" || node["node-name"] === "name" || node["node-name"] === "title") {
          const xmlId = node?.attributes.find((a: any) => a.name === "xml:id")?.value;
          if (xmlId) {
            elementNodes.push(xmlId);
          }
        }
        if (node["child-nodes"]) {
          recursiveSearch(node["child-nodes"]);
        }
      }
    };
  
    recursiveSearch(childNodes);
    return elementNodes;
  };
  const getFirstPNode = (childNodes: any[]) => {
    for (const child of childNodes) {
      if (child["node-name"] === "p") {
        return child?.attributes.find((a: any) => a.name === "xml:id")?.value;
      }
    }
    for (const child of childNodes) {
      if (child["node-name"] === "div") {
        const result: any = getFirstPNode(child["child-nodes"]);
        if (result) {
          return result;
        }
      }
    }
    return null
  };

  
const results = filterNodesWithNodeNameP(d.data[0], {});
  const dnodes = filterNodesWithNodeNameD(d.data[0], {});
  const pWithElementNodes = filterElementNodes(d.data[0], {});
  
  const elementToPNodesMap: any = {}
  Object.entries(pWithElementNodes).forEach(([key, value]: [string, any]) => {
    value.elementNodes.forEach((element: string) => {
      elementToPNodesMap[element] = [key];
    })
  })
  
  
  const pToDNodesMap: any = {}
  Object.entries(dnodes).forEach(([key, value]: [string, any]) => {
    const newKey = value.firstPNodeId;
    if (newKey){
      if (pToDNodesMap[newKey]) {
          pToDNodesMap[newKey].push({
          headNodes: value.headNodes,
          count: value.count,
          divid: key
        });
      }
      else{
        pToDNodesMap[newKey] = [{
          headNodes: value.headNodes,
          count: value.count,
          divid: key
        }];
      }
    }
    });
  
  return {
    data: d.data, 
    paraNodes: results,
    pToDNodesMap: pToDNodesMap,
    dnodes: dnodes,
    elementToPNodesMap: elementToPNodesMap
  }
  });



const NodeContext = createContext<any>({
  info: {},
  handleChangeInfo: (info: any) => {return info},
  handleChangeSecondaryInfo: (info: any) => {return info},
  handleChangePreviewInfo: (info: any) => {return info}
});

export const useNodes = () => {
  const context = useContext(NodeContext)
  if (context === undefined) {
    throw new Error('useNodes must be used within a NodesProvider');
  }
  return context;
}

interface NodeProviderProps{
  children: ReactNode,
  info: any
  secondaryInfo: any
  previewInfo: any
  handleChangeInfo: any
  handleChangeSecondaryInfo: any
  handleChangePreviewInfo: any
  relatedElements: any // are these being used anywhere?
  setRelatedElements: any // are these being used anywhere?
  itemRelatedExpressions: any[]
  setItemRelatedExpressions: any
  hoverFocus: any[]
  setHoverFocus: any
  commentAnnotations: any[]
  variantIndexList: any[]
  setCommentAnnotations: any
  textWrapperRef: any
  handleChangeDictInfo: any
}
// Provider component
export const NodeProvider: React.FC<NodeProviderProps> = (props) => {
  const info = props.info;
  const secondaryInfo = props.secondaryInfo;
  const previewInfo = props.previewInfo;
  const handleChangeInfo = props.handleChangeInfo
  const handleChangeSecondaryInfo = props.handleChangeSecondaryInfo
  const handleChangePreviewInfo = props.handleChangePreviewInfo
  const relatedElements = props.relatedElements
  const setRelatedElements = props.setRelatedElements
  const itemRelatedExpressions = props.itemRelatedExpressions
  const setItemRelatedExpressions = props.setItemRelatedExpressions
  const hoverFocus = props.hoverFocus
  const setHoverFocus = props.setHoverFocus
  const commentAnnotations = props.commentAnnotations
  const setCommentAnnotations = props.setCommentAnnotations
  const variantIndexList = props.variantIndexList
  const textWrapperRef = props.textWrapperRef
  const handleChangeDictInfo = props.handleChangeDictInfo
  
  
  
  const tshortid = info?.itemInfo?.transcriptionid?.split("/resource/")[1]

  const secondaryTshortid = secondaryInfo?.itemInfo?.transcriptionid?.split("/resource/")[1]

  const {data, error, isLoading} = useSWR(tshortid ? "https://exist.scta.info/exist/apps/scta-app/tei-to-json.xq?transcriptionid=" + tshortid : null, axiosFetcher, {
    revalidateOnFocus: false, // Turn off focus revalidation
    revalidateOnReconnect: true,
    refreshInterval: 0,
  })
  const {data: secondaryData, error: secondaryError, isLoading: secondaryIsLoading} = useSWR(secondaryTshortid ? "https://exist.scta.info/exist/apps/scta-app/tei-to-json.xq?transcriptionid=" + secondaryTshortid : null, axiosFetcher, {
    revalidateOnFocus: false, // Turn off focus revalidation
    revalidateOnReconnect: true,
    refreshInterval: 0,
  })
  // const [focusId, setFocusId] = useState(props.focusId);
  // const [structureType, setStructureType] = useState("");
  // Handle loading and error states
  if (error) {
    // console.log("error", error)
    return (<div>Error loading text </div>)
  }
  //if (isLoading) return <Spinner/>;
  return (
    <NodeContext.Provider value={{  data, secondaryData, error, info, secondaryInfo, handleChangeInfo, handleChangeSecondaryInfo, handleChangeDictInfo, isLoading, handleChangePreviewInfo, previewInfo, relatedElements, setRelatedElements, itemRelatedExpressions, setItemRelatedExpressions, commentAnnotations, setCommentAnnotations, variantIndexList, hoverFocus, setHoverFocus, textWrapperRef}}>
      {props.children}
    </NodeContext.Provider>
  );
};